"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'CreateSectorsModal',
  props: {
    isModalActive: {
      type: Boolean,
      default: false
    },
    isSaving: {
      type: Boolean,
      default: false
    }
  },
  emits: ['submit', 'onClose'],
  data: function data() {
    return {
      form: this.createDefaultForm()
    };
  },
  watch: {
    isModalActive: function isModalActive(active) {
      if (active) {
        this.resetForm();
      }
    }
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)({
    farm: 'GET_FARM'
  })),
  methods: {
    createDefaultForm: function createDefaultForm() {
      return {
        name: '',
        rows: [{
          name: ''
        }],
        hardeningArea: false
      };
    },
    resetForm: function resetForm() {
      this.form = this.createDefaultForm();
    },
    handleClose: function handleClose() {
      this.resetForm();
      this.$emit('onClose');
    },
    addRow: function addRow() {
      this.form.rows.push({
        name: ''
      });
    },
    removeRow: function removeRow(index) {
      if (this.form.rows.length === 1) return;
      this.form.rows.splice(index, 1);
    },
    submitForm: function submitForm() {
      var _this$farm;
      if (!this.form.name.trim()) {
        this.$buefy.toast.open({
          message: 'Informe o nome do setor.',
          type: 'is-danger'
        });
        return;
      }
      var rows = this.form.rows.map(function (row) {
        return {
          name: row.name.trim()
        };
      }).filter(function (row) {
        return row.name.length > 0;
      });
      if (!rows.length) {
        this.$buefy.toast.open({
          message: 'Adicione ao menos uma linha.',
          type: 'is-danger'
        });
        return;
      }
      var payload = {
        farmId: (_this$farm = this.farm) === null || _this$farm === void 0 ? void 0 : _this$farm.id,
        name: this.form.name.trim(),
        hardeningArea: this.form.hardeningArea,
        rows: rows
      };
      this.$emit('submit', payload);
    }
  }
};